var utils = require("../../shared/utils");
var containerHtml = require("html!./loginDropdown.html");

var $ = require("jquery");
var loginFooter = require("html!./loginFormFooter.html");

var selectors = {
    container: ".natp-login-container",
	form: ".natp-login-form",
	dropdownContainer: ".header-dropdown",
	trigger: "#login-trigger",
	errorLabel: ".natpLoginError"
};

var create = function(containerSelector) {
	containerSelector = containerSelector || selectors.container;

	var actions = {
		close: () => component.$container.removeClass("open"),
		open: () => component.$container.addClass("open")
	}
	var component = { actions, $container: $(containerSelector) };
	component.$container.html(containerHtml);

	$(selectors.trigger).on("click", function(e) {
        e.stopPropagation();
        $(document).trigger("header-section-toggle", component);
    });

	if (window.location.pathname.toLowerCase() === "/pages/login.aspx") {
		$(selectors.dropdownContainer).css("padding", 0);
	} else {
		$(selectors.form).appendTo(containerSelector + " " + selectors.dropdownContainer);
		$(selectors.form).append(loginFooter);
	
		if (component.$container.find(selectors.errorLabel).text().length){
			setTimeout(() => $(selectors.trigger).click(), 200);
		}

	}
	return component;
};

module.exports = { create: create };



// WEBPACK FOOTER //
// ./src/scripts/components/loginDropdown/index.js